'use client'

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import styles from './Logo.module.css'

const Logo = () => {
  const pathname = usePathname();
  const [logoSrc, setLogoSrc] = useState("/images/logoPadrao.svg");
  const [logoWidth, setLogoWidth] = useState(177);
  const [logoHeight, setLogoHeight] = useState(64);

  useEffect(() => {
    if (pathname === "/EuQuero/SolicitarBVA") {
      setLogoSrc("/images/logoAssinante.svg");
      setLogoWidth(160);
      setLogoHeight(64);
    } else if (pathname === "/Produtos/Corporativo") {
      setLogoSrc("/images/Logo_BV_Corporativa.svg");
      setLogoWidth(254);
      setLogoHeight(53);
    } else {
      setLogoSrc("/images/logoPadrao.svg");
      setLogoWidth(172);
      setLogoHeight(68);
    }
  }, [pathname]);

  return (
    <img
      className={styles.logoBV}
      src={logoSrc}
      aria-label="Logo Biblioteca Virtual"
      width={logoWidth}
      height={logoHeight}
      loading="lazy"
	  alt="Logo Biblioteca Virtual"
    />
  );
};

export default Logo;
